import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "LocalDataAccountSupport" */ './lazyIndex'),
    { name: 'LocalDataAccountSupport' }
);

export const lazyAddLocalDataAdditionalAccount: LazyAction<
    typeof lazyIndex.addLocalDataAdditionalAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addLocalDataAdditionalAccount);

export const lazyDoCleanupForRemovedLocalDataAccount: LazyAction<
    typeof lazyIndex.doCleanupForRemovedLocalDataAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.doCleanupForRemovedLocalDataAccount);

export const lazyCheckM365Installation: LazyAction<
    typeof lazyIndex.checkM365Installation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkM365Installation);

export const lazyCheckPstPrerequisites: LazyAction<
    typeof lazyIndex.checkPstPrerequisites,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkPstPrerequisites);

export const lazyCheckBulkTransferPrerequisites: LazyAction<
    typeof lazyIndex.checkBulkTransferPrerequisites,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkBulkTransferPrerequisites);

export const lazyCheckExportToPstPrerequisites: LazyAction<
    typeof lazyIndex.checkExportToPstPrerequisites,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.checkExportToPstPrerequisites);
